// extracted by mini-css-extract-plugin
export default {"noResultText":"search-no-results-panel__noResultText___z7xuY","logo":"search-no-results-panel__logo___EgqUu"};